<template>
  <edit-link-lock-exemption
    v-if="selectedUser.id"
    :tier="tierType"
    :id="selectedUser.id"
    :exemptionId="this.$route.params.id"
  />
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import EditLinkLockExemption from "@/views/Common/LinkLock/Exemptions/Edit/index.vue";

import { TIER } from "@/constants";

export default {
  name: "EditLinkLockExemptionWrapper",
  components: {
    EditLinkLockExemption,
  },
  data() {
    return {
      tierType: TIER.users,
    };
  },
  computed: {
    ...mapGetters("authentication", ["selectedUser"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle"]),
  },
  created() {
    this.setPageTitle(this.$t(`Id: ${this.$route.params.id}`));
  },
};
</script>
